import {Box, Chip, Typography} from '@mui/material';

import {EmpionTooltip} from '../../../../../../../components/EmpionTooltip/EmpionTooltip';
import {orangeColors} from '../../../../../../../layouts/theme/designSystem';
import {JobPostingCompanyAdmin} from '../../../types/JobPostingsTypes';

interface Props {
  companyAdmins: JobPostingCompanyAdmin[];
}

export const AssignedCompanyAdmins = ({companyAdmins}: Props) => {
  const assignedAdmins = companyAdmins.filter((admin) => admin.selected);
  const getInitials = (name: string) => {
    const trimmedName = name.trim();
    const names = trimmedName.split(' ');
    const initials = names[0].charAt(0);

    return <Typography variant='body2'>{initials}</Typography>;
  };

  return (
    <Box sx={{alignItems: 'center'}}>
      {assignedAdmins.map((admin, index) => (
        <EmpionTooltip key={admin.resourceId} isEnabled title={admin.name}>
          <Chip
            sx={{
              backgroundColor: orangeColors[3],
              marginLeft: index === 0 ? 0 : -1,
              zIndex: assignedAdmins.length - index, // Ensure the chips stack correctly
              borderRadius: '50%',
              border: `1px solid ${orangeColors[5]}`,
              width: 35,
              height: 35,
            }}
            label={getInitials(admin.name)}
          />
        </EmpionTooltip>
      ))}
    </Box>
  );
};
